"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var MediaManagerImage_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/MediaManagerImage"));
var polished_1 = require("polished");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var CenteredHeader_1 = tslib_1.__importDefault(require("../../../view/components/Header/CenteredHeader"));
var MAX_ITEM_WIDTH = 200;
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-items: center;\n  justify-content: center;\n  margin: ", ";\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-items: center;\n  justify-content: center;\n  margin: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(-theme.grid.gutterWidth / 2);
});
var Item = styled_components_1["default"].a(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  margin: ", ";\n  ", ";\n"], ["\n  margin: ", ";\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth / 2);
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth && styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), maxWidth);
});
var StyledMediaManagerImage = styled_components_1["default"](MediaManagerImage_1["default"])(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var maxHeight = _a.maxHeight;
    return maxHeight && styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      max-height: ", "px;\n    "], ["\n      max-height: ", "px;\n    "])), maxHeight);
});
var Partners = function (_a) {
    var renderEmpty = _a.renderEmpty, _b = _a.data, width = _b.width, _c = _b.pictures, pictures = _c === void 0 ? [] : _c, _d = _b.header, header = _d === void 0 ? '' : _d, type = _b.type;
    if ((!pictures || !pictures.length) && renderEmpty) {
        return renderEmpty(type);
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        header && react_1["default"].createElement(CenteredHeader_1["default"], null, header),
        react_1["default"].createElement(Wrapper, null, pictures.map(function (picture, idx) {
            var pic = picture.src ? { uri: picture.src } : picture;
            return (react_1["default"].createElement(Item, { title: picture.name || null, href: picture.url || '#', key: idx, maxWidth: width },
                react_1["default"].createElement(StyledMediaManagerImage, { picture: pic, naturalWidth: width || MAX_ITEM_WIDTH, naturalHeight: 0, maxHeight: width })));
        }))));
};
Partners.propTypes = {
    data: prop_types_1["default"].shape({
        header: prop_types_1["default"].string,
        width: prop_types_1["default"].number,
        pictures: prop_types_1["default"].arrayOf(prop_types_1["default"].shape({
            src: prop_types_1["default"].string,
            url: prop_types_1["default"].string,
            name: prop_types_1["default"].string
        })).isRequired
    }).isRequired,
    renderEmpty: prop_types_1["default"].func
};
exports["default"] = Partners;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
